type AlertWrapperProps = {
  children: React.ReactNode;
};

export default function AlertWrapper({ children }: AlertWrapperProps) {
  return (
    <div
      className="z-50 fixed -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 flex flex-col justify-center items-center
    min-w-[360px] p-[32px] border box-border rounded-[16px] border_primary surface_primary shadow-s"
    >
      {children}
    </div>
  );
}
